<!--
  功能：功能描述
  作者：oldgun
  邮箱：oldgun@sina.com
  时间：2020年04月09日 23:13:05
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="tfedu-box"> 
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
import store from "store";
import dataHandle from "@/assets/js/data-handle.js";
export default {
  // 组件名称
  name: "demo",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      // dialogRegisterVisible: false,
      // currentUsername: "请登录",
      // dialogLoginVisible: false,
      // username: "",
      // password: "",
      // isLogon: false
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    pausePlayListen () {
      // 关闭音频
      this.$store.dispatch('actionsSetAudioPlayId', 0);
    }
    // showCloseLoginDialog() {
    //   this.dialogLoginVisible = !this.dialogLoginVisible;
    // },
    // showCloseRegisterDialog() {
    //   window.location.href = "/static/reg.html";
    // },
    // login_clicked() {
    //   let u = {};
    //   u.username = this.username;
    //   u.password = this.password;
    //   dataHandle.executePost("/user/login", u, this).then(res => {
    //     if (res.code == 0) {
    //       this.isLogon = true;
    //       this.common.isLogon = true;
    //       this.$root.eventHub.$emit("logon-changed", true);
    //       store.set("username", u.username);
    //       store.set("current_user_id", res.data.id);
    //       store.set("truename", res.data.fullName);
    //       this.currentUsername = res.data.fullName;
    //       this.dialogLoginVisible = false;
    //       let user_bind = {};
    //       user_bind.UserCode = this.username;
    //       user_bind.UserTrueName = this.currentUsername;
    //       user_bind.UserTypeId = 2;
    //       user_bind.CourseId = 0;
    //       user_bind.GradeId = 6;
    //       user_bind.UserID = res.data.id;
    //       dataHandle
    //         .executePost("motk/user-bind/get-user-session", user_bind, this)
    //         .then(res => {
    //           let motk_session = JSON.parse(res);

    //           store.set("motk_session_id", motk_session.Value.SessionId);
    //           store.set(
    //             "motk_user-indicate_id",
    //             motk_session.Value.UserIndicateId
    //           );
    //           store.set("motk_expire_duration", motk_session.Value.ExpireAt);
    //           store.set("bind_motk_time", new Date());
    //         });
    //     }
    //   });
    // },
    // login_close_clicked() {
    //   this.dialogLoginVisible = false;
    // }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {},
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {
    window.pausePlayListen = this.pausePlayListen
    // this.$root.eventHub.$on(
    //   "show-login-dialog",
    //   () => (this.dialogLoginVisible = true)
    // );
    // this.$nextTick(() => {
    //   dataHandle.isLogon(this).then(res => {
    //     if (res.code == 0) {
    //       this.common.isLogon = true;
    //       this.currentUsername = store.get("truename");
    //     } else {
    //       this.currentUsername = "请登录";
    //       store.remove("truename");
    //       store.remove("username");
    //       store.remove("current_user_id");
    //       this.$root.eventHub.$emit("show-login-dialog");
    //     }
    //   });
    // });
  },
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<style lang="stylus">
  body.ML__fonts-loading .ML__base {
    visibility: visible!important;
  }
  .tfedu-box {
    height: 100%;
  }
</style>
